import apiMiddleware from "../../../api/apiMiddleware";

export const listRentalBookingsAdmin = async () => {
  const response = await apiMiddleware.get("/rental-bookings");
  return response.data;
};

export const updateRentalBookingStatusAdmin = async (id, payload) => {
  const response = await apiMiddleware.patch(`/rental-bookings/${id}/status`, payload);
  return response.data;
};

export const refundRentalBookingAmountAdmin = async (id, payload) => {
  const response = await apiMiddleware.post(`/rental-bookings/${id}/refund`, payload);
  return response.data;
};

